import QuizCreateContent from '../../components/admin/QuizCreateContent'
import Greeting from '../../components/common/Greeting'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import styles from '../../styles/common/Greeting.module.scss'
import { useLocation } from 'react-router-dom'

const QuizCreate = () => {
  const location = useLocation()
  const fromPage = location.state?.fromPage || 1
  const level = location.state?.level || 1

  return (
    <AdminLayout>
      <AdminContentLayout>
        <Greeting className={styles.adminGreeting} />
        <QuizCreateContent
          fromPage={fromPage}
          level={level}
        />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default QuizCreate
